import { SVGProps } from 'react'

export const DatabaseSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version='1.1'
      viewBox='0 0 1024 1024'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M512 62C322.37 62 118.25 119.195 118.25 244.835v534.33C118.25 904.715 322.37 962 512 962s393.75-57.285 393.75-182.835V244.835C905.75 119.195 701.585 62 512 62z m337.5 717.165c0 69.885-151.155 126.585-337.5 126.585s-337.5-56.7-337.5-126.585V674c58.095 59.895 198.27 91.035 337.5 91.035s279.405-31.095 337.5-91.035z m0-168.75v0.9c0 69.435-151.155 125.685-337.5 125.685s-337.5-56.25-337.5-125.685V505.295c58.095 59.895 198.27 91.035 337.5 91.035s279.405-31.095 337.5-91.035z m0-168.75v0.9c0 69.435-151.155 125.685-337.5 125.685S174.5 512 174.5 442.565V345.05c73.665 56.115 208.8 82.62 337.5 82.62s263.835-26.415 337.5-82.53z m-337.5-70.335c-186.345 0-337.5-56.7-337.5-126.585s151.155-126.585 337.5-126.585 337.5 56.655 337.5 126.585-151.155 126.585-337.5 126.585z m253.17 393.795a28.17 28.17 0 1 1-28.17 28.08 28.125 28.125 0 0 1 28.17-28.035z m0-168.795a28.17 28.17 0 1 1-28.17 28.17 28.125 28.125 0 0 1 28.17-28.17z m0-168.705a28.17 28.17 0 1 1-28.17 28.08 28.125 28.125 0 0 1 28.17-28.035z' />
    </svg>
  )
}
